module.exports = __webpack_public_path__ + "img/Desktop_Carousel4.7d6f8867.png";